import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { closeCreativePreviewPopup } from '../../actions/bannerCreativePreviewPopup';
import {
    CreativeCanvasIFrameProps,
    CreativePreviewIFrame
} from '../../components/CreativePreviewIFrame/CreativePreviewIFrame';
import { PreviewPopupVisibleType } from '../../typings/bannerCreativePreviewPopupState';
import { PcodeRenderData } from '../../typings/pcode';
import { State } from '../../typings/state';
import { Omit, TDispatchProps, TStateProps } from '../../typings/utils';

type StateProps = Omit<TStateProps<CreativeCanvasIFrameProps>, 'previewData'> & {
    previewData?: PcodeRenderData;
};
type DispatchProps = TDispatchProps<CreativeCanvasIFrameProps>;

const CreativePreviewIFrameWrapper = (props: CreativeCanvasIFrameProps) => {
    if (props.previewData && props.isVisible && props.previewUrl) {
        return <CreativePreviewIFrame {...props} />;
    }
    return null;
};

function mapStateToProps(state: State): StateProps {
    const {
        bannerCreativePreviewPopup: { previewPopupVisibleType, creativeUrl, pcodeRenderData }
    } = state;

    return {
        cspNonce: state.commonData.cspNonce,
        previewUrl: creativeUrl,
        previewData: pcodeRenderData,
        isVisible: previewPopupVisibleType === PreviewPopupVisibleType.bannerCreativePreview
    };
}

function mapDispatchToProps(dispatch: Dispatch<Action>): DispatchProps {
    return {
        onOutsideClick: () => {
            dispatch(closeCreativePreviewPopup());
        }
    };
}

export const CreativePreviewIFrameContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CreativePreviewIFrameWrapper);
